import { computed, Ref } from "vue";
import { useCustomMutation } from "@/api/graphqlClient/useCustomMutation";
import {
  SendOtpUsingSms,
  SendOtpUsingSms_sendOtpUsingSms_GenericSuccess,
  SendOtpUsingSmsVariables,
} from "@/api/phone/__generated__/SendOtpUsingSms";
import { sendOtpUsingSmsGql } from "@/api/phone/sendOtpViaSms";
import {
  SendOtpUsingSmsNonAuthenticated,
  SendOtpUsingSmsNonAuthenticated_sendOtpUsingSmsNonAuthenticated_GenericSuccess,
  SendOtpUsingSmsNonAuthenticatedVariables,
} from "@/api/phone/__generated__/SendOtpUsingSmsNonAuthenticated";
import { sendOtpUsingSmsNonAuthenticatedGql } from "@/api/phone/sendOtpUsingSmsNonAuthenticated";
import { parseGqlResponse } from "@/shared/utils/graphql/responseParser";
import { useStore } from "vuex";

export function useOtpSendViaSms(): {
  sendOtpViaSmsMutation?;
  sendOtpViaSmsLoading: Ref<boolean>;
  sendOtpViaSms: () => Promise<void>;
  sendOtpViaSmsNonAuthMutation?;
  sendOtpViaSmsNonAuthLoading: Ref<boolean>;
  sendOtpViaSmsNonAuth: ({
    username,
    password,
  }: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    username: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    password: any;
  }) => Promise<void>;
} {
  const store = useStore();

  // Send OTP via SMS Authenticated
  const sendOtpViaSmsMutation = useCustomMutation<
    SendOtpUsingSms,
    SendOtpUsingSmsVariables
  >(sendOtpUsingSmsGql);

  const sendOtpViaSms = async () => {
    const sendOtpViaSmsResponse = await sendOtpViaSmsMutation.mutate({
      input: {
        // Do not include app hash on web
        includeAppHash: false,
      },
    });

    const parsedGqlResponse =
      parseGqlResponse<SendOtpUsingSms_sendOtpUsingSms_GenericSuccess>(
        "GenericSuccess",
        sendOtpViaSmsResponse
      );

    if (parsedGqlResponse.data?.success) {
      store.dispatch("sendOtpViaSmsLastSent");
    } else {
      throw parsedGqlResponse.error || "Error on sending OTP via SMS";
    }
  };
  // END of Send OTP via SMS Authenticated

  // Send OTP via SMS Non Authenticated
  const sendOtpViaSmsNonAuthMutation = useCustomMutation<
    SendOtpUsingSmsNonAuthenticated,
    SendOtpUsingSmsNonAuthenticatedVariables
  >(sendOtpUsingSmsNonAuthenticatedGql);

  const sendOtpViaSmsNonAuth = async ({ username, password }) => {
    const sendOtpViaSmsNonAuthResponse =
      await sendOtpViaSmsNonAuthMutation.mutate({
        input: {
          password,
          username,
          // Do not include app hash on web
          includeAppHash: false,
        },
      });

    const parsedGqlResponse =
      parseGqlResponse<SendOtpUsingSmsNonAuthenticated_sendOtpUsingSmsNonAuthenticated_GenericSuccess>(
        "GenericSuccess",
        sendOtpViaSmsNonAuthResponse
      );

    if (parsedGqlResponse.data?.success) {
      store.dispatch("sendOtpViaSmsLastSent");
    } else {
      throw parsedGqlResponse.error || "Error on sending OTP via SMS";
    }
  };
  // END of Send OTP via SMS Non Authenticated

  return {
    sendOtpViaSmsMutation,
    sendOtpViaSmsLoading: computed(() => sendOtpViaSmsMutation.loading.value),
    sendOtpViaSms,
    sendOtpViaSmsNonAuthMutation,
    sendOtpViaSmsNonAuthLoading: computed(
      () => sendOtpViaSmsNonAuthMutation.loading.value
    ),
    sendOtpViaSmsNonAuth,
  };
}
